import { TbBrain } from "react-icons/tb";

import { PERMISSIONS } from "@/constants/permissions";
import type { NavigationRoute } from "@/types/navigation-route";
import { APP_ROUTES_TO } from "@/utils/routes";

export const aiRoutes: NavigationRoute[] = [
    {
        to: APP_ROUTES_TO.AI,
        meta: {
            label: "ai",
            order: 6,
            icon: TbBrain,
            visibleInSidebar: false,
            permissions: [PERMISSIONS.CALL_SVC_ADMIN_BASE],
        },
    },
];
